import React from 'react';

export const ConditionalRender = (props: { shouldRender: boolean, children: React.JSX.Element }): React.JSX.Element => {
    return props.shouldRender ? props.children : <></>;
};
